import React from 'react';
import { useTranslation } from 'react-i18next';
import { Utils } from '../../services';
import SelectField from '../SelectField/SelectField';

const ShowCalculatorField = ({ name }) => {
    const { t } = useTranslation();
    const options = Utils.showCalculatorOptions().map(option => ({
        key: option,
        text: t(`settings.payment.method.cash.show_calculator_${option}`),
        value: option,
    }));

    return (
        <SelectField
            name={name}
            options={options}
            format={v => (v == null || v === '' ? Utils.SHOW_CALCULATOR_OPTIONAL : v)}
            parse={v => v}
            clearable={false}
            search={false}
        />
    );
};

export default ShowCalculatorField;
